import React from 'react'
import ReactApexChart from 'react-apexcharts'

function WhiskerChart({w}) {
    const WiskerState = {
        series: [
          {
            data: [
              {
                x: 'Category A',
                y: w?.dataSet
              }
            ]
          }
        ],
        options: {
          chart: { 
            type: 'boxPlot',
            zoom: {
              enabled: false
            },
            toolbar: {
                show: false
            },
            sparkline: {
              enabled: true
           }
          },
        
          colors: ['#2E93fA'],
          markers: {
            size: 1,
            strokeColors: '#1976d2',
          } ,   
          title: {
                text: w?.title,
                align: 'left'
              },
          tooltip: {
            enabled: true,
            shared: false,
            intersect: true,
            style: {
              fontSize: '10px',
              fontFamily: undefined
            },
            marker: {
              show: false,
            },
            followCursor:false,
      
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            colors: ['#025481']
          },
          plotOptions: {
           
            bar: {
              columnWidth: "20%",
              horizontal: true,
              barHeight: '20%'
            },
            boxPlot: {
              colors: {
                upper: '#028DD5',
                lower: '#f8f9fa'
              }
            }
          },
        },  
       
      };

  return (
    <div style={{
    border: '1px solid #ccc', margin:'15px',
    borderRadius: '5px' , padding:'1px',minWidth:340}}>
    <ReactApexChart 
        options={WiskerState.options} 
        series={WiskerState.series} 
        type="boxPlot" 
        height={200} />
  </div>
  )
}

export default WhiskerChart